/* projects/shared/nvps-libraries/design/nv-dropdown-menu/nv-dropdown-menu.component.scss */
:host,
button.mat-mdc-menu-item {
  margin-right: 24px;
  font-size: var(--font-xs);
}
:host .mdc-list-item__primary-text,
:host .mat-mdc-menu-item-text,
:host .mdc-list-item__primary-text > div.primary-label-wrapper,
button.mat-mdc-menu-item .mdc-list-item__primary-text,
button.mat-mdc-menu-item .mat-mdc-menu-item-text,
button.mat-mdc-menu-item .mdc-list-item__primary-text > div.primary-label-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: auto;
}
:host .mdc-list-item__primary-text .label-wrapping-text,
:host .mat-mdc-menu-item-text .label-wrapping-text,
:host .mdc-list-item__primary-text > div.primary-label-wrapper .label-wrapping-text,
button.mat-mdc-menu-item .mdc-list-item__primary-text .label-wrapping-text,
button.mat-mdc-menu-item .mat-mdc-menu-item-text .label-wrapping-text,
button.mat-mdc-menu-item .mdc-list-item__primary-text > div.primary-label-wrapper .label-wrapping-text {
  display: flex;
  align-items: center;
  gap: var(--space-s);
}
:host .mat-mdc-menu-item-text > div.primary-label-wrapper,
button.mat-mdc-menu-item .mat-mdc-menu-item-text > div.primary-label-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: auto;
}
:host:has(.dropdown-item-tags) .mdc-list-item__primary-text,
:host:has(.dropdown-item-tags) .mat-mdc-menu-item-text,
button.mat-mdc-menu-item:has(.dropdown-item-tags) .mdc-list-item__primary-text,
button.mat-mdc-menu-item:has(.dropdown-item-tags) .mat-mdc-menu-item-text {
  display: grid;
}
:host:last-child,
button.mat-mdc-menu-item:last-child {
  border: none;
}
:host .dropdown-item-label,
button.mat-mdc-menu-item .dropdown-item-label {
  font-size: 14px;
  letter-spacing: 0.0168em;
  line-height: 145%;
  font-family: var(--font-family-normal);
  font-style: normal;
  font-weight: 400;
  font-family: var(--font-family-normal);
  font-weight: 400;
  text-transform: none;
  color: var(--color-grey-dark-9);
  text-align: left;
}
:host .dropdown-item-icon,
button.mat-mdc-menu-item .dropdown-item-icon {
  margin-left: 10px;
  float: right;
}
:host .dropdown-item-tags,
button.mat-mdc-menu-item .dropdown-item-tags {
  font-size: 10px;
  letter-spacing: 0.0144em;
  line-height: 100%;
  font-family: var(--font-family-normal);
  font-style: normal;
  font-weight: 400;
  font-family: var(--font-family-normal);
  font-weight: 700;
  text-transform: none;
  color: var(--color-grey-dark-9);
  opacity: var(--color-opacity-50);
}
:host .dropdown-item-tags .dropdown-item-tag:not(:last-child)::after,
button.mat-mdc-menu-item .dropdown-item-tags .dropdown-item-tag:not(:last-child)::after {
  content: ", ";
}
:host[disabled=true],
button.mat-mdc-menu-item[disabled=true] {
  cursor: not-allowed;
  opacity: 0.5;
}
:host.mat-mdc-menu-item-submenu-trigger,
button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger {
  padding-right: 16px;
}
:host.mat-mdc-menu-item-submenu-trigger .mat-mdc-menu-submenu-icon,
button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger .mat-mdc-menu-submenu-icon {
  display: none;
}
:host.mat-mdc-menu-item-submenu-trigger nv-icon,
button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger nv-icon {
  width: 20px;
}
:host:hover:not([disabled]),
:host.mat-mdc-menu-item-highlighted:not([disabled]),
button.mat-mdc-menu-item:hover:not([disabled]),
button.mat-mdc-menu-item.mat-mdc-menu-item-highlighted:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host.selection:not(.isPill),
:host.selection:focus:not([disabled]):not(.isPill),
button.mat-mdc-menu-item.selection:not(.isPill),
button.mat-mdc-menu-item.selection:focus:not([disabled]):not(.isPill) {
  background-color: var(--color-white);
}
:host.selection:not(.isPill) span,
:host.selection:focus:not([disabled]):not(.isPill) span,
button.mat-mdc-menu-item.selection:not(.isPill) span,
button.mat-mdc-menu-item.selection:focus:not([disabled]):not(.isPill) span {
  color: var(--color-blue);
  font-weight: var(--font-weight-bold);
}
:host.selection:not(.isPill):hover,
:host.selection:focus:not([disabled]):not(.isPill):hover,
button.mat-mdc-menu-item.selection:not(.isPill):hover,
button.mat-mdc-menu-item.selection:focus:not([disabled]):not(.isPill):hover {
  background-color: var(--color-blue-light-5);
}
:host.isPill,
button.mat-mdc-menu-item.isPill {
  align-items: center;
}
:host.isPill.selection,
:host.isPill.selection:focus:not([disabled]),
button.mat-mdc-menu-item.isPill.selection,
button.mat-mdc-menu-item.isPill.selection:focus:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host.isPill div.primary-label-wrapper,
button.mat-mdc-menu-item.isPill div.primary-label-wrapper {
  justify-content: center;
}
:host.parent-of-selection,
:host.parent-of-selection:hover:not([disabled]),
button.mat-mdc-menu-item.parent-of-selection,
button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
:host.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
button.mat-mdc-menu-item.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]) {
  background-color: var(--color-blue--light-5);
}
:host .label-warning-text,
button.mat-mdc-menu-item .label-warning-text {
  color: var(--color-red);
}
:host .disabled-option-text,
button.mat-mdc-menu-item .disabled-option-text {
  color: var(--color-grey);
  font-style: italic;
}
button.mat-mdc-menu-item.bottom-border {
  border-bottom: var(--standard-border);
}
.mat-mdc-menu-panel.scrollable {
  max-height: 224px;
}
.mat-mdc-menu-panel.scrollable-10-items {
  max-height: 548px;
}
.mat-mdc-menu-panel.dynamic-width-menu {
  width: auto;
  max-width: 400px;
}
.mat-mdc-menu-panel.wide-menu {
  width: auto;
  max-width: 560px;
}
:host nv-icon-button.option-with-icon {
  display: grid;
  grid-template-columns: 85% 15%;
  margin-right: 0;
}
:host nv-icon-button.option-with-icon.selection,
:host nv-icon-button.option-with-icon.selection:focus:not([disabled]) {
  background-color: var(--color-white);
}
:host nv-icon-button.option-with-icon.selection span,
:host nv-icon-button.option-with-icon.selection:focus:not([disabled]) span {
  color: white;
}
:host nv-icon-button.option-with-icon.selection:hover,
:host nv-icon-button.option-with-icon.selection:focus:not([disabled]):hover {
  background-color: var(--color-blue-light-5);
}
/*# sourceMappingURL=nv-dropdown-menu.component-RBX563MW.css.map */
